(async () => {
  const phoneInput = document.getElementById('phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function (e) {
      const input = e.target.value;

      const formatted = formatPhoneNumber(input);
      e.target.value = formatted;

      phoneInput.setCustomValidity('');
    });
  }
  document.querySelector('.pdp__main__callback__modal__form').addEventListener('submit', async function (e) {
    e.preventDefault();
    const submitButton = this.querySelector('.pdp__main__callback__modal__submit');

    const formData = new FormData(this);
    const data = Object.fromEntries(formData.entries());
    for (const entry of formData.entries()) {
      if (entry[0] === 'phone') {
        data[entry[0]] = prettyPrintPhoneNumber(entry[1]);
      }
    }
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    try {
      const response = await fetch('https://www.fpapplications.com/callbackRequests', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-store-id': '1',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        window.toast.success('Your callback request has been submitted successfully!', 5000);
        this.reset();
        document.querySelector('.js-callback-modal').classList.remove('active');
      } else {
        window.toast.error('There was an error submitting your request. Please try again.', 5000);
      }
    } catch (error) {
      console.error('Error:', error);
      window.toast.error('There was an error submitting your request. Please try again.', 5000);
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = 'Submit';
    }
  });
  document.querySelectorAll('.pdp__main__callback__button').forEach((btn) =>
    btn?.addEventListener('click', function () {
      document.querySelector('.js-callback-modal').classList.toggle('active');
    })
  );
  document.querySelector('.js-callback-modal')?.addEventListener('click', function (e) {
    if (e.target === this) {
      this.classList.remove('active');
    }
  });
  document.querySelector('.js-callback-modal-close')?.addEventListener('click', function () {
    document.querySelector('.js-callback-modal').classList.remove('active');
  });

  function isBusinessHours() {
    const now = new Date();
    const options = { timeZone: 'America/Chicago', hour: 'numeric', minute: 'numeric', hour12: false };
    const centralTime = new Intl.DateTimeFormat('en-US', options).formatToParts(now);
    const hour = parseInt(centralTime.find((part) => part.type === 'hour').value, 10);
    const minute = parseInt(centralTime.find((part) => part.type === 'minute').value, 10);
    const day = now.toLocaleDateString('en-US', { timeZone: 'America/Chicago', weekday: 'short' });
    return !(day === 'Sat' || day === 'Sun' || hour < 8 || (hour === 17 && minute > 30) || hour >= 18);
  }

  const callbackElements = document.querySelectorAll('.js-callback');
  const callbackOnlineElements = document.querySelectorAll('.js-callback-online');
  if (isBusinessHours()) {
    for (const callbackOnlineElement of callbackOnlineElements) {
      callbackOnlineElement.classList.remove('pdp__main__callback__modal__heading__online--inactive');
    }
  }

  const modal = document.querySelector('.js-callback-modal');
  const mobileProductImage = modal.querySelector('.pdp__main__callback__modal__image__img--mobile');
  const desktopProductImage = modal.querySelector('.pdp__main__callback__modal__image__img');
  const productTitleInput = modal.querySelector('input[name="product_title"]');
  const skuInput = modal.querySelector('input[name="sku"]');
  const urlInput = modal.querySelector('input[name="url"]');
  const domainInput = modal.querySelector('input[name="domain"]');
  if (!mobileProductImage.src) {
    const recentlyViewedProducts = localStorage.getItem('recently_viewed_v2')
      ? JSON.parse(localStorage.getItem('recently_viewed_v2'))
      : [];
    const handles = recentlyViewedProducts.map((p) => p.handle);
    fetch(`https://www.fpapplications.com/recent?currency=${window.CURRENCY_CODE}&handles=${handles.join(',')}`)
      .then((res) => res.json())
      .then((res) => {
        const title = res[0]?.title;
        const image = res[0]?.img_src;
        const sku = res[0]?.sku;
        mobileProductImage.src = image;
        desktopProductImage.src = image;
        productTitleInput.value = title;
        skuInput.value = sku;
        urlInput.value = `${window.location.hostname}/products/${res[0]?.handle}`;
        domainInput.value = window.location.hostname;
        // Only show request callback button if the price is greater than $500
        if (res[0]?.price > 500) {
          callbackElements.forEach((el) => {
            el.style.visibility = 'visible';
          });
        }
      });
  } else {
    const price = Number(document.querySelector('.js-price')?.innerText?.replace(/[^0-9.-]+/g, '') || 0);
    if (price > 500) {
      callbackElements.forEach((el) => {
        el.style.visibility = 'visible';
      });
    }
  }
  function formatPhoneNumber(number) {
    if (number.length > 10) {
      if (number.startsWith('+1')) {
        number = number.slice(2);
      } else if (number.startsWith('1') && number.replace(/\D/g, '').length === 11) {
        number = number.slice(1);
      }
      number = number.replace(/\D/g, '').slice(0, 10);
    }
    return number;
  }
  function prettyPrintPhoneNumber(number) {
    if (!number) return '';
    number = number.replace(/\D/g, '');
    if (number.length === 10) {
      return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
    } else if (number.length === 11 && number.startsWith('1')) {
      return `+1 (${number.slice(1, 4)}) ${number.slice(4, 7)}-${number.slice(7)}`;
    }
    return number;
  }
})();
